import { LinkTag } from '@thd-nucleus/thd-helmet';

export const imagePreloader = ({ data: contentData }) => {

  const imageUrlToPreload = contentData?.article?.articleHeader?.thumbnail;
  if (!imageUrlToPreload) {
    return [];
  }

  const tags = [
    new LinkTag({
      rel: 'preload', href: imageUrlToPreload, id: 'preloadFirstImg', as: 'image'
    })
  ];

  return tags;
};